import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollectionIconComponent } from '../../../collection/collection-icon/collection-icon.component';
import { AddRemoveButtonCollectionComponent } from './add-remove-button-collection/add-remove-button-collection.component';
import { TooltipDirective } from '../../../../directives/tooltip.directive';
import { CollectionFinderItemDTO } from '../../../../interfaces/collection.interface';
import { ClickOnAppBehavior, DisplayType } from '../../../../interfaces/app.interface';
import { NavigationItemsService } from '../../../../services/navigation-items-service/navigation-items.service';
import { ScrollService } from '../../../../services/scroll-service/scroll.service';

@Component({
  selector: 'collection-finder-item',
  imports: [
    CommonModule,
    CollectionIconComponent,
    AddRemoveButtonCollectionComponent,
    FormsModule,
    TooltipDirective,
  ],
  templateUrl: './collection-finder-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./collection-finder-item.component.scss'],
})
export class CollectionFinderItemComponent implements AfterContentChecked {
  @Input({ required: true }) collectionFinderData!: CollectionFinderItemDTO;
  @Input() displayType: DisplayType = DisplayType.BIG;
  @Input() clickOnAppBehavior: ClickOnAppBehavior = ClickOnAppBehavior.OPEN_APP_DETAILS;
  @Input() isCollectionFinderPage: boolean = false;
  @Input() recommendedSectionIdentification: string = '';

  @Output() isClicked: EventEmitter<void> = new EventEmitter<void>();
  protected readonly DisplayType = DisplayType;

  @ViewChild('titleElement') titleElement!: ElementRef;
  @Input() isFromDetailPage: boolean = false;

  constructor(
    private readonly changeDetectionRef: ChangeDetectorRef,
    private readonly navigationItems: NavigationItemsService,
    private readonly router: Router,
    private readonly scrollService: ScrollService,
  ) {}

  ngAfterContentChecked(): void {
    this.changeDetectionRef.detectChanges();
  }

  async openDetails(): Promise<void> {
    this.scrollService.savePosition(this.router.url);
    await this.router.navigate([
      this.navigationItems.getCollectionDetail().routerLink,
      this.collectionFinderData.id,
    ]);
    window.scroll(0, 0);
  }

  protected onCollectionClicked() {
    this.isClicked.emit();
    switch (this.clickOnAppBehavior) {
      case ClickOnAppBehavior.OPEN_APP_DETAILS:
        this.openDetails().then();
        break;
      case ClickOnAppBehavior.NO_BEHAVIOR:
        return;
      default:
        return;
    }
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  protected readonly ClickOnAppBehavior = ClickOnAppBehavior;
}
